import {
  AddFavoritesBlocksInSliderAction,
  AddViewedBlocksInSliderAction,
  IsRoutFromHomePage,
  PrivatePageChangeCurrentBlock,
  SetActiveSlideSliderAction
} from '../../../../store/actions';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ApplicationRoutingService } from '@application-routing';
import { AppState } from '@appStates';
import { LocalizationService, ScreenDetectedService } from '@core/services';
import { ListLazyComponents, TypeDevice } from '@enums';
import { BzProduct, IAdviceDay, IBanner, IToPharmacie, SliderItem } from '@interfaces';
import { ButtonModule, BzProductModule } from '../../../../modules-ui';
import { TranslocoModule } from '@ngneat/transloco';
import { select, Store } from '@ngrx/store';
import { selectFourProducts, selectViewedFourProducts } from '../../../../store/selectors';
import { SharedModule } from '@shared';
import { Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { RestUrlService, TypeUrl } from 'src/app/core/services/api.services/settings/rest-url.service';
import {
  listActiveBlockControlPanelSlide,
  selectActiveBlock,
  selectAdviceDayList,
  selectTopBookingList
} from 'src/app/store/selectors/start.page.selectors';
import { EntryComponentsStartPageModule } from '../../entryComponents/entry-components.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PrimaryColors } from '../../../../shared/enums/colors.app.enum';
import { AdvicesApiService } from '../../../../core/services/api.services/advices-api.service';
import { TopBookingApiService } from '../../../../core/services/api.services/top-booking-api.service';
import { BannersService } from 'src/app/core/services/api.services/banners.service';

@Component({
  selector: 'start-page-slider',
  templateUrl: './start-page-slider.component.html',
  styleUrls: ['./start-page-slider.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StartPageSliderComponent implements OnInit {
  public images: string;
  public bannerImages: string;
  public bid: number | string;
  public sid: number;
  public lang: string = 'ua';

  public activeSelectedBlock: Observable<SliderItem>;
  public listSlideBlockActive: Observable<{ id: number | string, active: boolean }[]>;

  public loadingBanners = true;

  public mainBanners: IBanner[] | null = null;
  public additionalBanners: IBanner[] | null = null;
  public shownBannerIndex: number = 0;

  public adviceDayList: Observable<IAdviceDay[]> = this.store.pipe(select(selectAdviceDayList));
  public topBookingProductsList: Observable<BzProduct[]> = this.store.pipe(select(selectTopBookingList));

  public readonly listComponent = ListLazyComponents;
  public readonly colorsApp: typeof PrimaryColors = PrimaryColors;

  trackById = (_: unknown, item: BzProduct) => item.id;

  constructor(
    private readonly store: Store<AppState>,
    private readonly locale: LocalizationService,
    private readonly screen: ScreenDetectedService,
    private readonly router: Router,
    private readonly appRoutingService: ApplicationRoutingService,
    private readonly advicesApiService: AdvicesApiService,
    private readonly topBookingApiService: TopBookingApiService,
    private readonly restUrlService: RestUrlService,
    private readonly bannersService: BannersService
  ) {
    this.bannerImages = this.restUrlService.getUrl(TypeUrl.img) + '/ad/';
    if (this.screen.isDesktop) {
      this.images = this.restUrlService.getUrl(TypeUrl.img) + '/188-188/';
    } else {
      this.images = this.restUrlService.getUrl(TypeUrl.img) + '/128-128/';
    }
  }

  ngOnInit(): void {
    this.lang = this.locale.getLang();
    this.loadBanners();
    this.advicesApiService.getAdviceDayTips();
    this.topBookingApiService.getTopBookingProducts();

    this.getListSlidesForActiveBlock(0);
    this.selectedBlock(0);
    this.selectedSlide(0);
  }

  public getListSlidesForActiveBlock(id: number | string): void {
    this.listSlideBlockActive = this.store.pipe(select(listActiveBlockControlPanelSlide, { id }));
  }

  public selectedBlock(id: number | string): void {
    this.activeSelectedBlock = this.store.pipe(select(selectActiveBlock, { id }));
    this.activeSelectedBlock.pipe(take(1)).subscribe((slideItem: SliderItem) => this.sid = slideItem.active);
    this.bid = id;
    this.getListSlidesForActiveBlock(id);
    this.updateSlider(+this.bid);
  }

  public selectedSlide(id: number): void {
    this.sid = id;
    this.store.dispatch(SetActiveSlideSliderAction({ bid: +this.bid, id }));
  }

  public filterActiveSlide = (item) => {
    if (this.screen.geTypeDevice() === TypeDevice.mobile) { return item.id === this.sid; }
    else { return item.id; }
  }

  public productEvent(event: IToPharmacie): void {
    if (event.type === 'toPharmcy') {
      this.router.navigate(this.locale.getReturnParamsLang(['pharmacies']), {
        queryParams: {
          id: event.idp.id,
          q: 1
        }
      });
    }

    if (event.type === 'toFavorite' || event.type === 'toList') {
      this.updateSlider(+this.bid);
    }

    if (this.bid === 1 && event.type === 'toFavorite') {
      this.selectedBlock(this.bid);
      this.selectedSlide(0);
    }

  }

  public updateSlider(idSlide: number): void {
    if (this.bid === idSlide) {
      this.store.pipe(take(1), select(selectFourProducts))
        .subscribe((favorites: BzProduct[]) =>
          this.store.dispatch(AddFavoritesBlocksInSliderAction({ favorites })));
    }

    if (this.bid === idSlide) {
      this.store.pipe(take(1), select(selectViewedFourProducts))
        .subscribe((vieweds: BzProduct[]) =>
          this.store.dispatch(AddViewedBlocksInSliderAction({ vieweds })));
    }
  }

  public onSwipe($event): void {
    const x: string = Math.abs($event.deltaX) > 40 ? ($event.deltaX > 0 ? 'Right' : 'Left') : '';
    let border: number;
    this.activeSelectedBlock.subscribe(sl => border = sl.slides.length).unsubscribe();
    let count: number = this.sid;
    switch (x) {
      case 'Right':
        count = count - 1;
        count = count < 0 ? (border - 1) : count;
        this.selectedSlide(count);
        break;
      case 'Left':
        count = count + 1;
        count = count > (border - 1) ? 0 : count;
        this.selectedSlide(count);
        break;

      default:
        break;
    }

  }

  public getAdviceLink(): string {
    return this.locale.getRouterLinkApp('tips');
  }

  public getMostOftenLink(): string {
    return this.locale.getRouterLinkApp('often');
  }

  public openPrivatePageBlock(id: ListLazyComponents, tab: string): void {
    if (this.screen.isMobile()) {
      this.store.dispatch(IsRoutFromHomePage({ isFromHome: true }));
    }
    switch (tab) {
      case 'orders':
        this.store.dispatch(PrivatePageChangeCurrentBlock({ currentBlock: 0 }));
        break;
      case 'favorite':
        this.store.dispatch(PrivatePageChangeCurrentBlock({ currentBlock: 2 }));
        break;
      case 'viewed':
        this.store.dispatch(PrivatePageChangeCurrentBlock({ currentBlock: 3 }));
        break;
      case 'history':
        this.store.dispatch(PrivatePageChangeCurrentBlock({ currentBlock: 1 }));
        break;
    }
    this.appRoutingService.navigate(id, this.router.routerState.snapshot.url);
  }

  public toCatalog(): void {
    if (this.locale.getLang() == 'ru') {
      this.router.navigate(['/catalog']);
    } else {
      this.router.navigate(['/ua/catalog']);
    }
  }

  public openAllTopReserves(): void {
    this.router.navigate(this.locale.getReturnParamsLang(['often']), { queryParams: { t: '1_allergy' } });
  }

  public openAllTipsPage(): void {
    this.router.navigate(this.locale.getReturnParamsLang(['tips']));
  }

  public prevSlide(): void {
    this.shownBannerIndex = this.shownBannerIndex - 1;
  }

  public nextSlide(): void {
    this.shownBannerIndex = this.shownBannerIndex + 1;
  }

  private loadBanners(): void {
    this.bannersService.getBannersForMainPage().pipe(
      finalize(() => this.loadingBanners = false),
      take(1)
    ).subscribe(({ main, additional }) => {
      this.mainBanners = main;
      this.additionalBanners = additional;    
    });
  }

}

@NgModule({
  declarations: [StartPageSliderComponent],
  exports: [
    StartPageSliderComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    EntryComponentsStartPageModule,
    TranslocoModule,
    BzProductModule,
    SharedModule,
    NgxSkeletonLoaderModule,
    RouterModule
  ]
})
export class StartPageSliderModule { }
